import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { paths } from '../../consts';
import { EventDataType, MagazineType, OtherDataType } from '../../../../common/types';

export interface IAwmacState {
  awmacMagazineItem: MagazineType | null,
  awmacMagazineList: MagazineType[],
  awmacLoader: boolean,
  awmacNotFound: boolean,
  awmacEventItem: EventDataType | null,
  awmacEventList: string[],
  awmacOtherItem: OtherDataType | null,
  awmacOtherList: { [key:string]: string },
  awmacOther: boolean,
  awmacEvent: boolean,
  awmacMag: boolean,
}

const initialState: IAwmacState = {
  awmacMagazineItem: null,
  awmacMagazineList: [],
  awmacLoader: false,
  awmacNotFound: false,
  awmacEventItem: null,
  awmacEventList: [],
  awmacOtherItem: null,
  awmacOtherList: {},
  awmacOther: false,
  awmacEvent: false,
  awmacMag: false,
};

export const fetchListOthers = createAsyncThunk('listOther/fetch', async () => {
  const { data } = await axios.get(`${process.env.REACT_APP_REST_API}${paths.IMAGESO}`);
  return data as any;
});

export const fetchListEvent = createAsyncThunk('listEvent/fetch', async (year: number) => {
  const path = `${process.env.REACT_APP_REST_API}${paths.IMAGESE}/${year}-Event-photos`;
  const { data } = await axios.get(path);
  return data as any;
});

// export const fetchListMagazines = createAsyncThunk('listMagazines/fetch', async (yearSeason: number) => {
//   const path = `${process.env.REACT_APP_REST_API}${paths.IMAGESM}/${yearSeason}`;
//   console.log(path, 'fhfggffg');
//   const { data } = await axios.get(path);
//   return data as any;
// });

export const awmacSlice = createSlice({
  name: 'awmac',
  initialState,
  reducers: {
    setterApp: (state, action: PayloadAction<Partial<IAwmacState>>) => ({ ...state, ...action.payload }),
  },
  extraReducers: (builder) => {
    builder.addCase(fetchListOthers.pending, (state) => {
      state.awmacLoader = true;
    });

    builder.addCase(fetchListOthers.fulfilled, (state, action: PayloadAction<string[]>) => {
      state.awmacOther = !action.payload;

      const processedOtherList: { [key:string]: string } = {};

      action.payload.forEach((str) => {
        const [idPict, fileName] = str.split('/');
        processedOtherList[idPict] = fileName;
      });

      state.awmacOtherList = processedOtherList;
      state.awmacLoader = false;
    });

    builder.addCase(fetchListEvent.pending, (state) => {
      state.awmacLoader = true;
    });

    builder.addCase(fetchListEvent.fulfilled, (state, action: PayloadAction<string[]>) => {
      state.awmacEvent = !action.payload;

      const processedEventList:string[] = [];

      action.payload.forEach((str) => {
        const fileName = str.split('/')[1];
        processedEventList.push(fileName);
      });

      state.awmacEventList = processedEventList;
      state.awmacLoader = false;
    });
    // builder.addCase(fetchListMagazines.pending, (state) => {
    //   state.awmacLoader = true;
    // });
    //
    // builder.addCase(fetchListMagazines.fulfilled, (state, action: PayloadAction<string>) => {
    //   state.awmacMag = !action.payload;
    //   console.log(action.payload);
    // const processedEventList:string[] = [];

    // action.payload.forEach((str) => {
    //   const fileName = str.split('/')[1];
    //   processedEventList.push(fileName);
    // });

    // state.awmacEventList = processedEventList;
    //   state.awmacLoader = false;
    // });
  },
});

export const {
  setterApp,
} = awmacSlice.actions;

export default awmacSlice.reducer;
